export interface EntityAutomationConfig {
  id: string;
  entity_type: string;
  entity_id: string;
  automation_kind: AutomationKind;
  /** app_users.id — user who set up this automation; used as assignee for generated tasks */
  created_by?: string | null;
  enabled: boolean;
  frequency: "daily" | "weekly" | "biweekly" | "monthly";
  day_of_week: number;
  run_on_business_days_only: boolean;
  selected_days_of_week: number[];
  use_title_template: boolean;
  task_title_template?: string;
  task_title_fixed?: string;
  task_description_template?: string;
  assigned_user_ids: string[];
  tags: string[];
  priority: "low" | "medium" | "high" | "urgent";
  goal_config?: CommunicationsGoalConfig | null;
  goal_last_posted_date?: string | null;
  goal_last_evaluated_at?: string | null;
  goal_last_status?: "red" | "green" | null;
  created_at: string;
  updated_at: string;
}

export const AUTOMATION_KINDS = {
  followUpTask: "follow_up_task",
  communicationsGoal: "communications_goal",
} as const;

export type AutomationKind = (typeof AUTOMATION_KINDS)[keyof typeof AUTOMATION_KINDS];

export const COMMUNICATIONS_GOALS_ENTITY_TYPE = "communications_goals";

export interface CommunicationsGoalConfig {
  weeklyTargets: {
    emails: number;
    calls: number;
    meetings: number;
    /** Optional — text-message goal. Absent on configs saved before texts existed. */
    texts?: number;
  };
  notifications: {
    postDaily: boolean;
    postToSalesChannel: boolean;
  };
  /**
   * Additional Hub accounts (`app_users.id`) this person also logs activity
   * under. The report sums communications from the primary + every linked
   * account. Empty/absent = single account only.
   */
  linkedUserIds?: string[] | null;
  /**
   * @deprecated Legacy single-account link. Superseded by `linkedUserIds`.
   * Still READ (via `resolveLinkedUserIds`) so rows saved before multi-account
   * support keep working; never written by new saves.
   */
  linkedUserId?: string | null;
}

export interface CommunicationsGoalAutomation {
  id: string;
  enabled: boolean;
  config: CommunicationsGoalConfig;
  createdBy: string | null;
  updatedAt: string;
}

export interface SaveMyCommunicationsGoalInput {
  enabled: boolean;
  weeklyTargets: {
    emails: number;
    calls: number;
    meetings: number;
    texts?: number;
  };
  postDaily: boolean;
  postToSalesChannel: boolean;
  /** Additional Hub accounts to also count activity from (`app_users.id`). */
  linkedUserIds?: string[] | null;
}
